<script setup lang="ts"></script>

<template>
  <div class="itp-progress-linear">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
  </div>
</template>

